module.exports = "pegasus_template/assets/blocks/column-16-theme6.png";